var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "van-popup",
        {
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "load-row" }, [
                _c("div", [
                  _c("img", {
                    attrs: {
                      src: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100",
                      alt: "Avatar",
                    },
                  }),
                ]),
                _c("div", [
                  _c("img", {
                    attrs: {
                      src: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100",
                      alt: "Avatar",
                    },
                  }),
                ]),
                _c("div", [
                  _c("img", {
                    attrs: {
                      src: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100",
                      alt: "Avatar",
                    },
                  }),
                ]),
                _c("div", [
                  _c("img", {
                    attrs: {
                      src: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=100",
                      alt: "Avatar",
                    },
                  }),
                ]),
                _c("div", [
                  _c("img", {
                    attrs: {
                      src: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=100",
                      alt: "Avatar",
                    },
                  }),
                ]),
              ]),
              _c("p", [
                _vm._v(" Processing your loan application "),
                _c("br"),
                _vm._v(" – this may take about 8-10 seconds. "),
              ]),
            ]),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }